// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merrieWeatherLight_61e1ce', '__merrieWeatherLight_Fallback_61e1ce', s, e, r, i, f","fontStyle":"normal"},"className":"__className_61e1ce"};